import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { clearGroupArms, toggleGroupConnector, updateOrArm } from '~/hooks/aiSearchFilterEdits';
import { createAiSearchBaseActions, createAiSearchStore, initialAiSearchBaseState } from '~/hooks/reactQuery/createAiSearchStore';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { pruneAgreementWideNameSearchArms } from './agreementWideNameSearch';
const FULLY_COVERED = {
    searchUnsupported: false,
    searchPartial: false
};
const store = createAiSearchStore([
    QueryKeys.AgreementsAiSearchState
], _object_spread_props(_object_spread({}, initialAiSearchBaseState(), FULLY_COVERED), {
    orArmMatchCounts: null
}));
const toFilterUpdate = (nextFilter)=>nextFilter == null ? {
        filter: null,
        lastQuery: ''
    } : {
        filter: nextFilter
    };
const baseActions = createAiSearchBaseActions(store, FULLY_COVERED);
const actions = _object_spread_props(_object_spread({}, baseActions), {
    clearFilter: ()=>{
        baseActions.clearFilter();
        store.setState({
            orArmMatchCounts: null
        });
    },
    setUnsupported: (lastQuery)=>store.setState({
            filter: null,
            lastQuery,
            filterEditedSinceLastSearch: false,
            searchUnsupported: true,
            searchPartial: false
        }),
    setPartial: (searchPartial)=>store.setState({
            searchPartial
        }),
    editFilter: (filter)=>store.setState(_object_spread({
            filter,
            filterEditedSinceLastSearch: true
        }, FULLY_COVERED)),
    setOrArm: (index, arm)=>store.setState((s)=>{
            const next = s.filter == null ? undefined : updateOrArm(s.filter, index, arm);
            return next === undefined ? {} : _object_spread_props(_object_spread({}, toFilterUpdate(next)), {
                filterEditedSinceLastSearch: true
            });
        }),
    toggleConnector: ()=>store.setState((s)=>{
            const toggled = s.filter == null ? undefined : toggleGroupConnector(s.filter);
            return toggled === undefined ? {} : {
                filter: toggled,
                filterEditedSinceLastSearch: true
            };
        }),
    clearGroup: ()=>store.setState((s)=>{
            const next = s.filter == null ? undefined : clearGroupArms(s.filter);
            return next === undefined ? {} : _object_spread_props(_object_spread({}, toFilterUpdate(next)), {
                filterEditedSinceLastSearch: true
            });
        }),
    applyOrArmMatchCounts: (counts)=>store.setState((s)=>{
            if (s.filter == null) return {};
            const recorded = {
                orArmMatchCounts: {
                    filter: s.filter,
                    counts
                }
            };
            if (counts == null || s.filterEditedSinceLastSearch) return recorded;
            const pruned = pruneAgreementWideNameSearchArms(s.filter, counts);
            return pruned === undefined ? recorded : _object_spread_props(_object_spread({}, recorded), {
                filter: pruned
            });
        })
});
export const useAgreementsAiSearchStore = Object.assign((selector)=>store.useStore((data)=>selector(_object_spread({}, data, actions))), {
    getState: ()=>_object_spread({}, store.getState(), actions),
    setState: store.setState
});
